import { __module as r } from "./ghl-ui.es1702.js";
import { i as m } from "./ghl-ui.es1541.js";
import { t as p } from "./ghl-ui.es1636.js";
import { t as x } from "./ghl-ui.es1631.js";
import { r as v } from "./ghl-ui.es1637.js";
(function(a, e) {
  var t = m.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var o = t(p), i = t(x), d = t(v);
  function s(u, n) {
    (0, d.default)(2, arguments);
    var l = (0, i.default)(u).getTime(), f = (0, o.default)(n);
    return new Date(l + f);
  }
  a.exports = e.default;
})(r, r.exports);
var M = r.exports;
export {
  M as a
};
